import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { GenericalRecord } from '../../../types/utilities'

import { ContextMenuStoreContext } from './contexts/StoreContext'
import { ContextMenuStoreProviderProps } from './interface'
import { createContextMenuStore } from './store/createStore'
import { ContextMenuStoreUpdater } from './StoreUpdater'

export const ContextMenuStoreProvider = <T extends GenericalRecord>({
  offset,
  onClose,
  onOpen,
  children
}: PropsWithChildren<ContextMenuStoreProviderProps<T>>) => {
  const store = useCreation(() => createContextMenuStore(), [])

  return (
    <ContextMenuStoreContext value={store}>
      <ContextMenuStoreUpdater
        offset={offset}
        onClose={onClose}
        onOpen={onOpen}
      />
      {children}
    </ContextMenuStoreContext>
  )
}
